var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-table',{attrs:{"responsive":"","stacked":"sm","no-border-collapse":"","small":"","hover":"","items":_vm.items,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }